import { User } from './user';

export class MedicalCondition {
  name!: string;
  description!: string;
  category!: string;
  status!: string;
  date_deleted?: number;
  uuid!: string;
  user_uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;

  constructor(data: any) {
    this.name = data.name;
    this.description = data.description;
    this.category = data.category;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.user_uuid = data.user_uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
